import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors'


Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
          light: {
            primary: colors.indigo,
            secondary: colors.grey.darken1,
            accent: colors.orange.accent4,
            error: colors.red.accent3,
          },
          dark: {
            primary: colors.indigo.lighten3,
            accent: colors.orange.accent1,
          },
        },
    }
});
